export const getDv360LineItemDates = lineItem => {
  const startDate = lineItem?.flight?.date_range?.start_date
  const endDate = lineItem?.flight?.date_range?.end_date

  return { startDate, endDate }
}
